var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z",
    fill: "#C3E9C7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0001 14.0015C15.1175 13.6676 15.3494 13.386 15.6546 13.2066C15.9597 13.0273 16.3185 12.9617 16.6674 13.0216C17.0163 13.0814 17.3327 13.2628 17.5607 13.5336C17.7887 13.8044 17.9134 14.1471 17.9129 14.5011C17.9129 15.5004 16.414 16 16.414 16M16.4333 18H16.44M16.3334 21.3333C19.463 21.3333 22.0001 18.7963 22.0001 15.6667C22.0001 12.5371 19.463 10 16.3334 10C13.2038 10 10.6667 12.5371 10.6667 15.6667C10.6667 16.3 10.7706 16.9091 10.9623 17.4777C11.0345 17.6917 11.0705 17.7987 11.077 17.881C11.0835 17.9621 11.0786 18.019 11.0585 18.098C11.0382 18.1779 10.9933 18.261 10.9035 18.4272L9.81303 20.4456C9.65749 20.7335 9.57972 20.8774 9.59713 20.9885C9.61229 21.0853 9.66924 21.1705 9.75286 21.2215C9.84886 21.2801 10.0116 21.2632 10.3371 21.2296L13.7511 20.8767C13.8545 20.866 13.9062 20.8606 13.9533 20.8624C13.9997 20.8642 14.0324 20.8686 14.0776 20.879C14.1235 20.8896 14.1813 20.9118 14.2968 20.9564C14.9289 21.1999 15.6156 21.3333 16.3334 21.3333Z",
    stroke: "#36B544",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/question-mark.8602514d068884adcee6a4c2f5b3f38c.svg";
export { ForwardRef as ReactComponent };